import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class MembersScrollTrigger {
  constructor(el) {
    gsap.registerPlugin(ScrollTrigger);

    this.dom = {el: el};
    this.dom.trigger = this.dom.el;
    this.dom.wrapper = this.dom.el.querySelector('[data-js="members-wrapper"]');
    this.dom.slides = this.dom.el.querySelectorAll('[data-js="members-slide"]');

    this.slideLength = this.dom.slides.length;
    this.slideW = {
      sp: 260,
      pc: 492
    }
    this.baseW = {
      sp: 375,
      pc: 1440
    }
    this.slideWidth = 0;
    this.moveX = 0;
    this.end = 0;

    this.mql = window.matchMedia('screen and (min-width: 768px)');    
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.init();
  }

  init() {

    // ブレイクポイントの瞬間に発火
    this.mql.addListener(this.checkBreakPoint);
    // 初回チェック
    this.checkBreakPoint(this.mql);

    
    gsap.to(this.dom.slides, {
      xPercent: this.moveX,
      ease: 'none',
      scrollTrigger: {
        trigger: this.dom.trigger,
        start: 'bottom 100%',
        end: this.end,
        pin: true,
        scrub: 1.05,
      }
    });
  }

  set() {
    gsap.set(this.dom.wrapper, {
      width: `${this.slideWidth}%`
    });
    gsap.set(this.dom.slides, {
      width: 100 / this.slideLength + '%'
    });
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');
      this.slideWidth = (this.slideLength * this.slideW.sp) / this.baseW.sp * 100;
      this.moveX = -100 * (this.slideLength - 1) + (((85 + 30) / this.slideW.sp) * 100);
      this.end = '+=1000';
      this.set();
      
      return;
    } else {
      // console.log('pc');
      this.slideWidth = (this.slideLength * this.slideW.pc) / this.baseW.pc * 100;
      this.moveX = -100 * (this.slideLength - 1) + (((804 + 144) / this.slideW.pc) * 100);
      this.end = '+=1500';
      this.set();
      
      return;
		}
	}
}

export default MembersScrollTrigger